module.exports = __webpack_public_path__ + "img/autodesk_logo_generic.87397c0b.svg";